import React from 'react';
import ClockLoader from 'react-spinners/ClockLoader';
import { Box, Card, CardContent, Typography, Grid, Divider, Paper } from "@mui/material";

export default function ReviewMultiYearRequestData({ formData, loading, currentData }) {
  console.log('FORMDATA', formData);
  console.log('CURRENTDATA', currentData);

  function DateFormat(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    const day = new Intl.DateTimeFormat('en-US', { day: 'numeric' }).format(date);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(date);
    return `${day}-${month}-${year}`;
  }

  function AmountFormat(amount) {
    if (amount === null || amount === undefined || amount === "") return "-";
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 2,
    }).format(amount);
  }

  const DetailItem = ({ label, value, md = 3, sm = 6, xs = 12 }) => (
    <Grid item xs={xs} sm={sm} md={md}>
      <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: 'block', mb: 0.5 }}>
        {label}
      </Typography>
      <Typography variant="body1" color="text.primary" sx={{ fontWeight: 500, wordBreak: 'break-word' }}>
        {value || "-"}
      </Typography>
    </Grid>
  );

  const SectionTitle = ({ title }) => (
    <Typography variant="h6" sx={{ color: "#ce690a", fontWeight: "bold", mb: 3, mt: 1, pb: 1, borderBottom: '2px solid #f0f0f0' }}>
      {title}
    </Typography>
  );

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <ClockLoader color="#1976d2" loading={loading} size={150} aria-label="Loading Spinner" data-testid="loader" />
      </Box>
    );
  }

  return (
    <Box sx={{ p: { xs: 1, md: 3 } }}>
      <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <CardContent sx={{ p: { xs: 2, md: 5 } }}>
          
          <SectionTitle title="Applicant Details" />
          <Grid container spacing={3}>
            <DetailItem label="First Name" value={formData.applicant?.firstName} md={2} />
            {formData.applicant?.lastName && (
              <DetailItem label="Last Name" value={formData.applicant?.lastName} md={2} />
            )}
            <DetailItem label="Aadhar Number" value={formData.applicant?.aadharcardnumber} md={3} />
            <DetailItem label="Date of Birth" value={DateFormat(formData.applicant?.dob)} md={2} />
            <DetailItem label="Email" value={formData.applicant?.appemail} md={3} />
            <DetailItem label="Phone Number" value={formData.applicant?.phonenumber} md={3} />
            <DetailItem label="Address" value={formData.address?.addressone} md={9} />
            <DetailItem label="City" value={formData.address?.city} md={3} />
            <DetailItem label="State" value={formData.address?.state} md={3} />
            <DetailItem label="District" value={formData.address?.district} md={3} />
            <DetailItem label="Pincode" value={formData.address?.pincode} md={3} />
          </Grid>

          <Box sx={{ my: 4 }} />
          
          <SectionTitle title="Parent/Guardian Details" />
          <Grid container spacing={3}>
            <DetailItem label="Father Name" value={formData.parentorguardian?.fathername} />
            <DetailItem label="Father Occupation" value={formData.parentorguardian?.fatherprofession} />
            <DetailItem label="Mother Name" value={formData.parentorguardian?.mothername} />
            <DetailItem label="Mother Occupation" value={formData.parentorguardian?.motherprofession} />
            <DetailItem label="Family Income" value={AmountFormat(formData.parentorguardian?.familyincomepm)} />
            <DetailItem label="Family Members" value={formData.parentorguardian?.familyCount} />
          </Grid>

          <Box sx={{ my: 4 }} />
          
          <SectionTitle title="Indian Reference Details" />
          <Grid container spacing={3}>
            <DetailItem label="Referral Name" value={formData.indiavolunteer?.ivname} md={3} />
            <DetailItem label="Referral Email" value={formData.indiavolunteer?.ivemail} md={3} />
            <DetailItem label="Referral Phone" value={formData.indiavolunteer?.ivphone} md={3} />
            <DetailItem label="Relationship with Referral" value={formData.indiavolunteer?.relationtoapplicant} md={3} />
          </Grid>

          <Box sx={{ my: 4 }} />
          
          <SectionTitle title="USA Volunteer Details" />
          <Grid container spacing={3}>
            <DetailItem label="Volunteer Name" value={formData.usavolunteer?.usvname} md={4} />
            <DetailItem label="Volunteer Email" value={formData.usavolunteer?.email} md={4} />
            <DetailItem label="Volunteer Phone" value={formData.usavolunteer?.usvphone} md={4} />
          </Grid>

          <Box sx={{ my: 4 }} />
          
          <SectionTitle title="Aid Request Details" />
          <Grid container spacing={3}>
            <DetailItem label="Aid Request Amount" value={AmountFormat(currentData.amountRequested)} md={3} />
            <DetailItem label="Aid Type" value={formData.aidinformation?.aidtype} md={5} />
            {(formData.aidinformation?.courseType || formData.aidinformation?.finalYearOfPassing) && (
              <>
                <DetailItem label="Course Type" value={formData.aidinformation?.courseType} md={2} />
                <DetailItem label="Final Year of Passing" value={formData.aidinformation?.finalYearOfPassing} md={2} />
              </>
            )}
            <DetailItem label="Aid Request Reason" value={formData.aidinformation?.reasonforrequesting} md={12} />
          </Grid>

          <Box sx={{ my: 4 }} />

          <SectionTitle title="Institution Details" />
          <Grid container spacing={3}>
            <DetailItem label="Institution Name" value={formData.institutiondetails?.name} md={4} />
            <DetailItem label="Email" value={formData.institutiondetails?.email} md={4} />
            <DetailItem label="Mobile Number" value={formData.institutiondetails?.mobileNumber} md={4} />
            <DetailItem label="Address" value={formData.institutiondetails?.address} md={8} />
            <DetailItem label="City" value={formData.institutiondetails?.city} md={2} />
            <DetailItem label="State" value={formData.institutiondetails?.state} md={2} />
            <DetailItem label="District" value={formData.institutiondetails?.district} md={2} />
            <DetailItem label="Pincode" value={formData.institutiondetails?.pincode} md={2} />
            <DetailItem label="Beneficiary Name" value={formData.paymentmethod?.beneficiaryname} md={5} />
            <DetailItem label="Beneficiary Phone" value={formData.paymentmethod?.beneficiaryphone} md={5} />
          </Grid>

          <Box sx={{ my: 4 }} />

          <SectionTitle title="Payment Details" />
          <Grid container spacing={3}>
            <DetailItem label="Account Number" value={currentData.accountNumber} md={3} />
            <DetailItem label="IFSC Code" value={currentData.ifscCode} md={2} />
            <DetailItem label="Bank Name" value={currentData.bankName} md={3} />
            <DetailItem label="Branch Name" value={currentData.branchName} md={4} />
            <DetailItem label="Branch Address" value={currentData.paymentAddress} md={12} />
          </Grid>
          
        </CardContent>
      </Paper>
    </Box>
  );
}
